
<div class="p-grid">
    <div class="p-col-12 page-header">Professional</div>
    <div class="p-col-12 divider-header">
        <p-divider></p-divider>
    </div>
    <div class="p-col-6 p-lg-2 p-md-2 p-sm-2" *ngIf="canEditProfile">
        <button pButton type="submit" class="fullwidthbtn" label="Edit" routerLink="/user/edit/{{user.Id}}"></button>
    </div>
    <div class="p-col-6 p-lg-2 p-md-2 p-sm-2">
        <button pButton type="button" class="fullwidthbtn" label="New Deal" routerLink="/deal/new"></button>
    </div>
    <div class="p-col-6 p-lg-2 p-md-2 p-sm-2">
        <button pButton type="button" class="fullwidthbtn" label="Print" (click)="PrintProfilePDF()"></button>
    </div>
</div>
<div class="card">
    <div class="p-grid">
        <div class="p-col-12 p-lg-3 p-md-3">
            <img class="p-col-12 profilePicture" [src]="user.ProfilePicture" />
        </div>
        <div class="p-col-12 p-lg-9 p-md-9">
            <div class="p-grid">
                <div class="p-col-12 p-lg-6 p-md-6">
                    <div class="message-header">
                        <i class="pi pi-star" style="font-size: 1.3rem; padding-right: .3rem;"
                           [ngStyle]="{'color': (user.IsFavorite) ? '#D99F00' : '#E1E3E3'}" (click)="UpdateUserFavorite()">
                        </i>
                        {{user.FName}}  {{user.LName}}                      
                    </div>
                </div>                
            </div>            
            <div class="p-grid">
                <div class="p-col-12" *ngIf="user.Active==false">
                    <p-message severity="warn" text="This profile is inactive." styleClass="mr-2"></p-message>
                </div>
                <div class="p-col-12" *ngIf="(defaultMember == null && canEditProfile)">
                    <p-message severity="warn" text="No Default Office assinged to this profile. Please edit profile to select default office." styleClass="mr-2"></p-message>
                </div>
                <div class="p-col-12 p-lg-6 p-md-6" *ngIf="defaultMember?.Name">
                    <strong>NAI Office: </strong>
                    <p-button label=" {{defaultMember.Name}}" styleClass="p-button-link" routerLink="/member/{{defaultMember.Id}}"></p-button>
                </div>
                <div class="p-col-12 p-lg-6 p-md-6" *ngIf="user.Title"><strong>Title: </strong>{{user.Title}}</div>
                <div class="p-col-12 p-lg-6 p-md-6" *ngIf="user.Email"><strong>Email: </strong><a class="hyperLink" href="mailto:{{user.Email}}">{{user.Email}}</a></div>
                <div class="p-col-12 p-lg-6 p-md-6" *ngIf="user.CellPhone"><strong>Mobile: </strong>{{user.CellPhone}}</div>
                <div class="p-col-12 p-lg-6 p-md-6" *ngIf="user.DirectPhone"><strong>Office Phone: </strong>{{user.DirectPhone}}</div>
                <div class="p-col-12 p-lg-6 p-md-6" *ngIf="user.Fax"><strong>Fax: </strong>{{user.Fax}}</div>
                <div class="p-col-12 p-lg-6 p-md-6" *ngIf="user.PrimarySpecialty"><strong>Primary Specialty: </strong>{{user.PrimarySpecialty}}</div>
                <div class="p-col-12 p-lg-6 p-md-6" *ngIf="user.LicenseNumber"><strong>License Number: </strong>{{user.LicenseNumber}}</div>
                <div class="p-col-12 p-lg-6 p-md-6 hyperlink" *ngIf="user.MyPropertyListingUrl"><strong>My Property Listing Url: </strong><a target="_blank" [href]="formatUrl(user.MyPropertyListingUrl)">{{formatUrlforDisplay(user.MyPropertyListingUrl)}}</a></div>
                <div class="p-col-12 p-lg-6 p-md-6" *ngIf="defaultMember?.Address"><strong>Address: </strong>{{defaultMember.Address}}</div>
                <div class="p-col-12 p-lg-6 p-md-6" *ngIf="defaultMember?.City"><strong>City: </strong>{{defaultMember.City}}</div>
                <div class="p-col-12 p-lg-6 p-md-6" *ngIf="defaultMember?.StatesName"><strong>State: </strong>{{defaultMember.StatesName}}</div>
                <div class="p-col-12 p-lg-6 p-md-6" *ngIf="defaultMember?.PostalCode"><strong>Zip: </strong>{{defaultMember.PostalCode}}</div>
                <div class="p-col-12 p-lg-6 p-md-6" *ngIf="user.VCard">
                    <strong>VCard: </strong>
                    <input class="imageButton" type="image" src="assets/layout/images/naiimages/card-address.png" (click)="downloadVCard()">
                </div>
            </div>
            <div style="margin-bottom:20px; margin-top: 10px;" *ngIf="user.FacebookID||user.TwitterID||user.YoutubeID||user.GooglePlusID||user.LinkedINID||user.BlogUrl||user.BlogRSSFeedUrl">
                <a target="_blank" *ngIf="user.FacebookID" href="https://www.facebook.com/{{user.FacebookID}}"><img src="assets/layout/images/naiimages/social/facebook.jpg" width="35" height="35" />&nbsp;&nbsp;</a>
                <a target="_blank" *ngIf="user.TwitterID" href="https://twitter.com/{{user.TwitterID}}"><img src="assets/layout/images/naiimages/social/twitter.jpg" width="35" height="35" />&nbsp;&nbsp;</a>
                <a target="_blank" *ngIf="user.YoutubeID" href="https://www.youtube.com/channel/{{user.YoutubeID}}"><img src="assets/layout/images/naiimages/social/youtube.jpg" width="35" height="35" />&nbsp;&nbsp;</a>
                <a target="_blank" *ngIf="user.InstagramID" href="https://instagram.com/{{user.InstagramID}}"><img src="assets/layout/images/naiimages/social/instagram.jpg" width="35" height="35" />&nbsp;&nbsp;</a>
                <a target="_blank" *ngIf="user.LinkedINID" href="https://www.linkedin.com/in/{{user.LinkedINID}}"><img src="assets/layout/images/naiimages/social/linkedin.jpg" width="35" height="35" />&nbsp;&nbsp;</a>
                <a target="_blank" *ngIf="user.BlogUrl" href="{{user.BlogUrl}}"><img src="assets/layout/images/naiimages/social/blog.jpg" width="35" height="35" />&nbsp;&nbsp;</a>
                <a target="_blank" *ngIf="user.BlogRSSFeedUrl" href="{{user.BlogRSSFeedUrl}}"><img src="assets/layout/images/naiimages/social/rss.png" width="35" height="35" /></a>
            </div>
            <div class="" *ngIf="user.EducationDescription||user.ScopeOfExperience||user.Bio||user.ProfessionalAffiliations||user.SignificantTransactions||user.StrategicClients">
                
                <div class="" *ngIf="user.Specialties!= null && user.Specialties.length >0">
                    <div class="message-header-small">Specialties</div>
                    <div class="p-col-12 p-lg-12 p-md-12 innerText" innerHTML="{{userSpecialties}}"></div>
                </div>
                <div class="" *ngIf="user.EducationDescription">
                    <div class="message-header-small">Education</div>
                    <div class="p-col-12 p-lg-12 p-md-12 innerText" innerHTML="{{user.EducationDescription}}"></div>
                </div>
                <div class="" *ngIf="user.ScopeOfExperience">
                    <div class="message-header-small">Scope Of Experience</div>
                    <div class="p-col-12 p-lg-12 p-md-12 innerText" innerHTML="{{user.ScopeOfExperience}}"></div>
                </div>
                <div class="" *ngIf="user.Bio">
                    <div class="message-header-small">Background & Experience</div>
                    <div class="p-col-12 p-lg-12 p-md-12 innerText" innerHTML="{{user.Bio}}"></div>
                </div>
                <div class="" *ngIf="user.ProfessionalAffiliations">
                    <div class="message-header-small">Professional Affiliations</div>
                    <div class="p-col-12 p-lg-12 p-md-12 innerText" innerHTML="{{user.ProfessionalAffiliations}}"></div>
                </div>
                <div class="" *ngIf="user.SignificantTransactions">
                    <div class="message-header-small">Significant Transactions</div>
                    <div class="p-col-12 p-lg-12 p-md-12 innerText" innerHTML="{{user.SignificantTransactions}}"></div>
                </div>
                <div class="" *ngIf="user.StrategicClients">
                    <div class="message-header-small">Strategic Clients</div>
                    <div class="p-col-12 p-lg-12 p-md-12 innerText" innerHTML="{{user.StrategicClients}}"></div>
                </div>
            </div>
            </div>
        </div>
</div>




